var _circle, _path, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.002,
    cy: 43,
    r: 42.3848,
    fill: "#66CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9828 6.7836C15.1649 10.3208 10.2848 15.2077 6.75548 21.0304C3.2262 26.8532 1.15167 33.4406 0.707477 40.2349C0.263284 47.0293 1.4625 53.8306 4.20363 60.0634C6.94476 66.2961 11.1471 71.7767 16.455 76.0413C21.7629 80.3059 28.0201 83.229 34.6969 84.5631C41.3738 85.8973 48.2738 85.6032 54.813 83.7059C61.3521 81.8085 67.3379 78.3637 72.2638 73.6629C77.1896 68.9622 80.9104 63.1439 83.1113 56.7006L43.002 43L20.9828 6.7836Z",
    fill: "#F0F0F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 40,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6944_148181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 36.0098H63",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 52.0098H35",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 52.0098H48",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.88 26.0098H54.1C61.22 26.0098 63 27.7698 63 34.7898V51.2098C63 58.2298 61.22 59.9898 54.12 59.9898H31.88C24.78 60.0098 23 58.2498 23 51.2298V34.7898C23 27.7698 24.78 26.0098 31.88 26.0098Z",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6944_148181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentInProgress);
export default __webpack_public_path__ + "static/media/payment-in-progress.93e9e84d610cd2b899e10b072222fe54.svg";
export { ForwardRef as ReactComponent };